export class CodigosSAT {
    id?: number = -1;
    clave_prod_serv: string = "";
    descripcion_prod_serv: string = "";
    clave_unidad: string = "";
    descripcion_unidad: string = "";
    fechaHoraUM: Date;
    unidadServicio: number = -1;
}